module.exports = __webpack_public_path__ + "media/images/sp/stores/sola/how-to-enjoy-sola-06-378412e4003a5d3f770545c9f32302e4.jpg";